<h1 mat-dialog-title>Warning</h1>
<mat-dialog-content>One or more products selected have either been Ingested and/or Shot.
    <br /> changing or removing MasterSuite will<strong> clear all data from the Product! </strong>
    <br />
    Are you sure you wish to proceed?
</mat-dialog-content>
<mat-dialog-actions style="justify-content: end;">
    <button mat-stroked-button (click)="onNoClick()">No</button>
    <button mat-button (click)="onYesClick()" #create color="buttonWarn">Yes</button>
</mat-dialog-actions>